import React from "react";
import classes from "./Modal.module.css";
import NavItems from "../../Nav/NavItems/NavItems";
import CloseIcon from "../../../assets/icons/x.svg";

function Modal(props) {
  return (
    <div
      className={classes.Modal}
      style={props.show ? { transform: "translateX(0)", width: "70%" } : null}
    >
      <div onClick={props.closeModal} className={classes.ModalCloseBtn}>
        <img src={CloseIcon} alt="Close Icon" />
      </div>
      <NavItems />
    </div>
  );
}

export default Modal;
